module.exports = __webpack_public_path__ + "img/58.6539132e.jpg";